import { Quaternion } from '@babylonjs/core/Maths';
import { SolidParticle } from '@babylonjs/core/Particles/solidParticle';
import { CircularPatternFeature } from '@models/classes/features/circular-pattern-feature';
import { Token } from '@models/classes/token';
import { SubmeshVertexData } from '@view/helpers/geometry-helper';
import { PatternRenderer } from './pattern';

export class CircularPatternRenderer extends PatternRenderer {
    modelToken = Token.CircularPatternFeature;
    updateMeshGeometry(
        feature: CircularPatternFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const featurePivot = feature.pivot.toVec3();
        const featureAxis = feature.axis.toVec3();
        // Don't allow a zero vector for an axis because it will blow up the math
        if (featureAxis.equalsToFloats(0, 0, 0)) {
            featureAxis.set(0, 1, 0);
        }
        const featureArc = (feature.arc * Math.PI) / 180 / feature.count;
        const workingQuaternion = Quaternion.Identity();

        return super.updateMeshGeometry(
            feature,
            vertexData,
            vertexDataChanges,
            (idx: number, particle: SolidParticle) => {
                particle.pivot = featurePivot;
                Quaternion.RotationAxisToRef(featureAxis, featureArc * idx, workingQuaternion);
                particle.rotationQuaternion!.multiplyInPlace(workingQuaternion);
            }
        );
    }
}
